import { authAPI } from '@/api/new-api'
import { ClientModel } from '@/models/features/clients'

export interface GetClientsWithCountRequest {
  buildingId?: number
  search?: string
  skip?: number
  limit?: number
  apartment?: string
  filter?: string
}

export interface GetClientsWithCountResponse {
  count: number
  clients: ClientModel[]
}

export const getClientsWithCount = async (
  data: GetClientsWithCountRequest,
  signal?: AbortSignal,
) => {
  const { buildingId, search, skip, limit, apartment, filter } = data
  const response = await authAPI.get<GetClientsWithCountResponse>(`/client-with-count`, {
    params: { apartment, buildingId, filter, limit, search, skip },
    signal,
  })

  return response.data
}
